import Button from '@components/Button';
import { ButtonProps, Stack, SxProps, Theme } from '@mui/material';

interface FormActionButtonsProps {
    onCancel: () => void;
    onSubmit?: () => void;
    cancelLabel?: string;
    submitLabel?: string;
    loading?: boolean;
    cancelDisabled?: boolean;
    submitDisabled?: boolean;
    submitType?: ButtonProps['type'];
    size?: ButtonProps['size'];
    containerSx?: SxProps<Theme>;
}

interface FormCancelButtonProps {
    onCancel: () => void;
    label?: string;
    disabled?: boolean;
    size?: ButtonProps['size'];
}

interface FormSubmitButtonProps {
    onSubmit?: () => void;
    label?: string;
    loading?: boolean;
    disabled?: boolean;
    type?: ButtonProps['type'];
    size?: ButtonProps['size'];
}

export const FormCancelButton = ({
    onCancel,
    label = 'Annuler',
    disabled = false,
    size = 'small',
}: FormCancelButtonProps) => {
    return (
        <Button
            type="button"
            onClick={onCancel}
            variant="outlined"
            size={size}
            disabled={disabled}
            sx={{
                textTransform: 'none',
                borderRadius: '10px',
                borderColor: theme => theme.palette.border.main,
                color: theme => theme.palette.neutralWhite.main,
            }}>
            {label}
        </Button>
    );
};

export const FormSubmitButton = ({
    onSubmit,
    label = 'Enregistrer',
    loading = false,
    disabled = false,
    type = 'submit',
    size = 'small',
}: FormSubmitButtonProps) => {
    return (
        <Button
            type={type}
            onClick={onSubmit}
            variant="contained"
            size={size}
            disabled={disabled}
            loading={loading}
            sx={{
                textTransform: 'none',
                borderRadius: '10px',
                color: theme => theme.palette.neutralWhite.main,
            }}>
            {label}
        </Button>
    );
};

const FormActionButtons = ({
    onCancel,
    onSubmit,
    cancelLabel = 'Annuler',
    submitLabel = 'Enregistrer',
    loading = false,
    cancelDisabled,
    submitDisabled,
    submitType = 'submit',
    size = 'small',
    containerSx,
}: FormActionButtonsProps) => {
    return (
        <Stack direction="row" spacing={1.5} justifyContent="flex-end" sx={containerSx}>
            <FormCancelButton
                onCancel={onCancel}
                label={cancelLabel}
                size={size}
                disabled={cancelDisabled ?? loading}
            />
            <FormSubmitButton
                onSubmit={onSubmit}
                label={submitLabel}
                size={size}
                type={submitType}
                loading={loading}
                disabled={submitDisabled ?? loading}
            />
        </Stack>
    );
};

export default FormActionButtons;
